import {Outlet} from 'react-router-dom'
import {Paper, Block} from 'common/components'
import styles from './Main.module.scss'
import {TopPanel} from './components/TopPanel'

export default function Main() {
  return (
    <Paper className={styles.root}>
      <TopPanel />
      <Block className={styles.block}
        type="grey"
      >
        <Outlet />
      </Block>
    </Paper>
  )
}
